module.exports = __webpack_public_path__ + "media/src/office/images/octo-logo-b1ccaf4d076dbb7f919511c98befcfce.png";